import React, { Component } from 'react';

import { getDistanceMessage } from '../../services';

//TODO:   Use NEW ETA Logic..
function DeliveryMinutes(location) {
	var DeliveryMessage = '';
	const leadTime = location.LeadTimeMinutes ? location.LeadTimeMinutes : 60;
	const deliveryMinutes = leadTime + Math.ceil(location.DistanceMiles);
	if (deliveryMinutes > 0) {
		DeliveryMessage = `est. ${deliveryMinutes} min*`;
	}
	return DeliveryMessage;
}
class Service extends Component {
	render() {
		var { installLocations, shippingLocations, roadsideLocations, deliveryLocations, pickupLocations } =
			this.props.item;

		if (!installLocations) {
			installLocations = [];
		}
		if (!shippingLocations) {
			shippingLocations = [];
		}
		if (!roadsideLocations) {
			roadsideLocations = [];
		}
		if (!deliveryLocations) {
			deliveryLocations = [];
		}
		if (!pickupLocations) {
			pickupLocations = [];
		}

		const { providerLocation } = this.props;
		var open_now = false;
		var city = '';
		if (providerLocation && providerLocation.location) {
			if (providerLocation.location.googlePlacesData) {
				if (providerLocation.location.googlePlacesData.result) {
					open_now = providerLocation.location.googlePlacesData.result.opening_hours.open_now;
				}
			}
			if (providerLocation.location.address) {
				city = providerLocation.location.address.city;
			}
		}
		return (
			<div className="services-container mb-3">
				{providerLocation && providerLocation.location && (
					<div className="service-item">
						<div className="image">
							<i className="fas fa-store-alt"></i>
						</div>
						<div className="content">
							<h6>Welcome to Store# {providerLocation.location.id}</h6>
							{open_now && (
								<p>
									<span>
										Open Now {' in '}
										<span className="clickable">{city}</span>
									</span>
								</p>
							)}
							{!open_now && (
								<p>
									<span>
										Open Tomorrow{' in '}
										<span className="clickable">{city}</span>
									</span>
								</p>
							)}
						</div>
					</div>
				)}
				{installLocations && installLocations.length > 0 && (
					<div className="service-item">
						<div className="image">
							<i className="fas fa-tools"></i>
						</div>
						<div className="content">
							<h6>Installation Available</h6>
							<p>
								<span>We are {getDistanceMessage(installLocations[0].DistanceMiles)}</span> in{' '}
								<span className="clickable">
									{installLocations[0].City}, {installLocations[0].State}
								</span>
								.
							</p>

							{installLocations && installLocations.length > 1 && (
								<p className="mt-2">
									<i className="far fa-info-circle"></i> {installLocations.length - 1} other Locations
									Available
								</p>
							)}
						</div>
					</div>
				)}

				{pickupLocations && pickupLocations.length > 0 && (
					<div className="service-item">
						<div className="image">
							<i className="fas fa-tools"></i>
						</div>
						<div className="content">
							<h6>Pickup Available</h6>
							<p>
								<span>We are {getDistanceMessage(pickupLocations[0].DistanceMiles)}</span> in{' '}
								<span className="clickable">
									{pickupLocations[0].City}, {pickupLocations[0].State}
								</span>
								.
							</p>

							{pickupLocations && pickupLocations.length > 1 && (
								<p>
									<i className="far fa-info-circle"></i> {pickupLocations.length - 1} other Locations
									Available
								</p>
							)}
						</div>
					</div>
				)}

				{(installLocations.length > 0 || pickupLocations.length > 0) && (
					<div className="service-item">
						<div className="image">
							<i className="fas fa-calendar-day"></i>
						</div>
						<div className="content">
							<h6>Same Day</h6>
						</div>
					</div>
				)}

				{shippingLocations.length > 0 && (
					<div className="service-item">
						<div className="image">
							<i className="fas fa-shipping-fast"></i>
						</div>
						<div className="content">
							<h6>Fast Shipping</h6>
							<p>
								From:{' '}
								<span className="clickable">{`${shippingLocations[0].City}, ${shippingLocations[0].State}`}</span>
							</p>
						</div>
					</div>
				)}

				{deliveryLocations.length > 0 && (
					<div className="service-item">
						<div className="image">
							<i className="fas fa-shipping-fast"></i>
						</div>
						<div className="content">
							<h6>Delivery Available</h6>
							<p>{DeliveryMinutes(deliveryLocations[0])}</p>
						</div>
					</div>
				)}

				{roadsideLocations.length > 0 && (
					<div className="service-item">
						<div className="image">
							<i className="fas fa-tools"></i>
						</div>
						<div className="content">
							<h4>Roadside Service Available</h4>
							<p>Be careful and stay in your car in a seatbelt.</p>
						</div>
					</div>
				)}

				<div className="service-item">
					<div className="image">
						<i className="fas fa-user-lock"></i>
					</div>
					<div className="content">
						<h6>Safe and Secure</h6>
						<p>We keep your data private.</p>
					</div>
				</div>
			</div>
		);
	}
}

export default Service;
